// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popper[data-v-55b4f9ce]  li:hover{color:#2d6cfc;cursor:pointer;background:#f3f2f2}", ""]);
// Exports
module.exports = exports;
